<template>
  <div class="testimonial-section">
    <h2>On leur a promis de tranformer leurs Actions Anti-gaspi en réelles Economies €€€</h2>
    <div class="carousel-wrapper">
      <v-carousel cycle height="370" hide-delimiter-background>
        <v-carousel-item v-for="group in groupedTestimonials" :key="group[0].id">
          <v-row justify="center" align="stretch" no-gutters>
            <v-col v-for="testimonial in group" :key="testimonial.id" cols="12" sm="4">
              <v-card class="prospect-card d-flex flex-column justify-center align-center pa-6" elevation="3">
                <v-card-title class="font-weight-bold text-center prospect-title mb-2">
                  {{ testimonial.restaurantName }}
                </v-card-title>
                <div class="prospect-row d-flex flex-row align-center mb-2">
                  <img :src="testimonial.image" :alt="testimonial.restaurantName" class="prospect-img mr-4" />
                  <div class="prospect-desc text-left mb-2">
                    <span class="font-italic">{{ testimonial.description }}</span>
                    <blockquote class="prospect-quote font-italic mt-2">“{{ testimonial.testimonial }}”</blockquote>
                  </div>
                </div>
                <div class="d-flex justify-center mt-2">
                  <v-chip :color="getStatusColor(testimonial.status)" dark class="prospect-status">
                    {{ getStatusLabel(testimonial.status) }}
                  </v-chip>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>
<style scoped>
.testimonial-section {
  margin-top: 3rem;
  margin-bottom: 3rem;
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.carousel-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 60px;
}
.prospect-card {
  max-width: 340px;
  min-height: 220px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  background: #fff;
  margin: 0 auto;
  padding-bottom: 1.2rem;
  padding-top: 1.2rem;
}
.testimonial-title {
  font-size: 1.3rem;
  color: #1976d2;
  margin-bottom: 1rem;
}
.prospect-title {
  font-size: 1.1rem;
  color: #1976d2;
}
.prospect-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
}
.prospect-img {
  max-width: 80px;
  max-height: 80px;
  object-fit: cover;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.07);
  flex-shrink: 0;
}
.prospect-desc {
  font-size: 0.95rem;
  color: #424242;
  line-height: 1.3;
  word-break: break-word;
  flex: 1;
  min-width: 0;
}
.prospect-quote {
  color: #616161;
  font-size: 0.92rem;
  margin-top: 0.5rem;
  line-height: 1.2;
}
.prospect-status {
  font-weight: bold;
  font-size: 0.92rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.09);
}
/* Status colors for marketing effect */
.prospect-status[style*="background-color: grey"] {
  background-color: #ed6aff !important;
}
.prospect-status[style*="background-color: blue"] {
  background-color: #615fff !important;
}
.prospect-status[style*="background-color: orange"] {
  background-color: #34a6f4 !important;
}
.prospect-status[style*="background-color: yellow"] {
  background-color: #36bba7 !important;
  color: #222 !important;
}
.prospect-status[style*="background-color: green"] {
  background-color: #31c950 !important;
}
</style>

<script>
export default {
  name: "ProspectTestimonialCarousel",
  data() {
    return {
      testimonials: [],
    }
  },
  computed: {
    groupedTestimonials() {
      // Regroupe les testimonials par 3 pour chaque slide
      const groups = []
      for (let i = 0; i < this.testimonials.length; i += 3) {
        groups.push(this.testimonials.slice(i, i + 3))
      }
      return groups
    },
  },
  methods: {
    fetchTestimonials() {
      this.$store
        .dispatch("fetchProspectTestimonials", { limit: 20, offset: 0 })
        .then((data) => {
          console.log(data.results)
          this.testimonials = data.results
        })
        .catch(() => {
          this.$store.dispatch("notifyServerError")
        })
    },
    getStatusLabel(status) {
      const labels = {
        interesse: "Intérêssé",
        pret: "Prêt à sauter le pas",
        deploiement: "Déploiement en cours",
        analyse: "Analyse les économies",
        constate: "Constate les économies",
      }
      return labels[status] || status
    },
    getStatusColor(status) {
      const colors = {
        interesse: "grey",
        pret: "blue",
        deploiement: "orange",
        analyse: "yellow",
        constate: "green",
      }
      return colors[status] || "primary"
    },
  },
  mounted() {
    this.fetchTestimonials()
  },
}
</script>

<style scoped>
.v-carousel-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
